import React, { useCallback, useEffect, useState } from 'react';
import { Row, Stack } from 'react-bootstrap';
import { asve } from '../orve';
import { getTipContent, shuffleArray } from '../report-util';
import { REPORT_TYPE } from '../../../../utils/constants';

function AcumenTips({ candidate, reportType = REPORT_TYPE.coaching }) {
  const [acumenTips, setAcumenTips] = useState([]);
  const [acumenScore, setAcumenScore] = useState(0);
  const [initialized, setInitialized] = useState(false);

  const getAcumenTips = useCallback(() => {
    const tips = [];
    for (let a = 0; a < 4; a++) {
      tips.push(
        <Stack direction="horizontal" className="pb-2" key={a}>
          <div>{getTipContent(acumenTips[a].title, acumenScore, acumenTips[a].text, undefined, reportType)}</div>
        </Stack>
      );
    }
    return tips;
  }, [acumenTips]);

  useEffect(() => {
    if (!initialized && candidate) {
      if (reportType === REPORT_TYPE.development) {
        setAcumenTips(shuffleArray(candidate, asve(candidate).developmentAcumenTips));
      } else {
        setAcumenTips(shuffleArray(candidate, asve(candidate).acumenTips));
      }
      if (candidate.percentiles.acumen > 66) {
        setAcumenScore(5);
      } else if (candidate.percentiles.acumen < 33) {
        setAcumenScore(1);
      } else {
        setAcumenScore(4);
      }
      setInitialized(true);
    }
  }, [candidate]);

  return (
    <>
      {initialized && candidate.percentiles.acumen < 66 && (
        <>
          <h3 className="pt-4 pb-3">ACUMEN</h3>
          <Row className="w-100 mx-auto justify-content-center pt-1">{getAcumenTips()}</Row>
        </>
      )}
    </>
  );
}

export default AcumenTips;
